export default "/images/bg-ai.svg?674875a9f549f69fdacdaa3c85253de3";